<template>
  <v-container fluid class="px-0 py-0">
    <CommonTable
        title="MaterialEvent"
        :embedded="embedded"
        :top-height="topHeight"
        :dto-list-query="dtoListQuery"
        :dto-detail-query="dtoDetailQuery"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :store-name="storeName"
        :detail-store-name="detailStoreName"
        detailComponentPass="/CoreMaterial/MaterialEvent/MaterialEventDetail"
        :parent-component="$options.name"
        :main-validator="true"
    >
      <template v-slot:item.provider_uid="{ item }">
        <span v-if="!!item.provider_uid && storeAggregate.rootData && !!storeAggregate.rootData[item.provider_uid]">
          {{storeAggregate.rootData[item.provider_uid].name}}
        </span>
      </template>
      <template v-slot:item.comment="{ item }">
        <span v-if="!!item.event && !!item.event['comment']">
          {{item.event['comment']}}
        </span>
      </template>
      <template v-slot:footer.prepend>
        <slot name="footer.prepend"></slot>
      </template>
    </CommonTable>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import MaterialEventDetail from "@/components/CoreMaterial/MaterialEvent/MaterialEventDetail";
import BaseFieldCheck from "@/components/Base/BaseFieldCheck";

export default {
  name: "MaterialEventTable",

  props: {
    embedded: {default: false},
    topHeight: {default: 0},
    storeName: {type: [String], default: 'MaterialEventTable'},
    dtoDetailQuery: {default: 'MaterialEventDetailQueryDTO'},
    detailStoreName: {default: 'MaterialEventDetail'},
    dtoValidateCommand: {type: [String], default: 'MaterialEventValidateCommandDTO'},
    dtoListQuery: {type: [String], default: 'MaterialEventListQueryDTO'},
    dtoActionCommand: {type: [String], default: 'MaterialEventActionCommandDTO'},
    mainValidator: {type: [Boolean], default: false},
  },

  components: {
    CommonTable,
    MaterialEventDetail,
    BaseFieldCheck,
  },

  methods: {
  },

  mounted() {
    this.storeTable = useTableStore(this.storeName)()
    this.storeTable.headers = [
      {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
      // {text: 'uid', value: 'uid', sortable: true, filterable: true, divider: true, width: 300},
      {text: 'Material', value: 'material_uid', sortable: true, filterable: true, divider: true},
      {text: 'Event type', value: 'event_type', sortable: true, filterable: true, divider: true},
      {text: 'Event', value: 'event', sortable: false, filterable: true, divider: true},
      {text: 'Comment', value: 'comment', sortable: false, filterable: true, divider: true},
      // {text: 'Event', value: 'event', sortable: true, filterable: true, divider: true},
      // {text: 'Event', value: 'event', sortable: true, filterable: true, divider: true},
      {text: 'edited_by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'edited_on', value: 'edited_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: 'created_by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'created_on', value: 'created_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
    ]
    this.storeAggregate = useAggregateStore()
    if (!!this.storeAggregate) {
      this.storeTable.dtoDetailQuery = this.dtoDetailQuery
      this.storeTable.dtoListQuery = this.dtoListQuery
      this.storeTable.dtoActionCommand = this.dtoActionCommand
      this.storeTable.options.sortBy = ['edited_on']
    }
  },

  data() {
    return {
      storeAggregate: null,
    }
  },
}
</script>

<style scoped>

</style>


<i18n src="@/components/CoreMaterial/locales.json">
</i18n>